import { useFormContext } from 'react-hook-form';

import { FormControl, FormField } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';

const formData = [
  {
    label: 'Flags & Initials',
    formKey: 'flagsAndInitialsEnabled',
  },
  {
    label: 'Electric Effect',
    formKey: 'electricEffectEnabled',
  },
  {
    label: 'ChatGPT',
    formKey: 'gptEnabled',
  },
];

export function AiConfiguration() {
  const { control } = useFormContext();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:grid-cols-2 grid-flow-col grid-rows-6 sm:grid-rows-1">
      {formData.map((formField) => (
        <div className="gap-5 flex flex-col" key={formField.formKey}>
          <h3 className="text-2xl font-semibold text-zinc-50">
            {formField.label}
          </h3>
          <FormField
            control={control}
            name={formField.formKey}
            render={({ field }) => (
              <FormControl>
                <label
                  htmlFor={formField.formKey}
                  className="cursor-pointer flex items-center gap-2 text-zinc-100"
                >
                  <Switch
                    id={formField.formKey}
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                  <span className="text-medium">
                    {field.value ? 'Enable' : 'Disable'}
                  </span>
                </label>
              </FormControl>
            )}
          />
        </div>
      ))}
    </div>
  );
}
